export default "__VITE_ASSET__8262f5e1__"